<template>
  <div class="booxBanner-page">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <component :is="tab"></component>
    </transition>
  </div>
</template>

<script>
import { uploadOss } from "@/utils/aliyun";
import tabHeader from "@/components/tabHeader";
import zh from "./zhBanner";
import en from "./enBanner";
export default {
  components: {
    tabHeader,
    zh,
    en
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: "中文广告轮播",
          component: "zh"
        },
        {
          name: "英文广告轮播",
          component: "en"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: "zh"
    };
  },
  methods: {
    headerTabBack(tab) {
      this.tab = tab.component;
    }
  }
};
</script>

<style lang="scss">
.booxBanner-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
